module.exports = __webpack_public_path__ + "static/media/1015507.c3c82bfb.png";